/* eslint-disable no-param-reassign */
import { useEffect, useRef } from 'react';
import axios from 'axios';
import * as url from '../helpers/url_helper';

// apply base URL for axios
const API_URL = '';

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

const refreshToken = async (rt, at) => {
  try {
    axiosApi.defaults.headers.common['x-access-token'] = at;

    const response = await axiosApi
      .post(url.POST_JWT_REFRESH, { refresh_token: rt }, {})
      .then((res) => res.data);

    return response;
  } catch (error) {
    return false;
  }
};

const logoutAction = () => {
  window.location.pathname = '/logout';
};

async function check(timerRef) {
  const dt = new Date().getTime();
  const user = JSON.parse(localStorage.getItem('authUser'));
  const edt = user.expiresAt - 480 * 1000; // 480-second buffer

  if (dt > edt) {
    const data = await refreshToken(user.refreshToken, user.token);

    if (data !== false) {
      user.token = data.token;
      user.expiresAt = data.expiresAt;

      localStorage.setItem('authUser', JSON.stringify(user));

      timerRef.current = setTimeout(() => check(timerRef), 60000);
    } else {
      logoutAction();
    }
  } else {
    timerRef.current = setTimeout(() => check(timerRef), 60000);
  }
}

const LogoutTimer = ({ children }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    // Clear the existing timer if it exists
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Start the timer
    check(timerRef);

    // Cleanup function to clear timer on unmount or re-render
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []); // Empty dependency array ensures this runs only on mount/unmount

  return children;
};

export default LogoutTimer;
